import { Box, styled } from '@material-ui/core';

import { TextColor } from '@setvi/shared/enums';
import { distances } from '@setvi/shared/styles';
import { SSearchInput } from '@setvi/shared/components';

export const FlexBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 12,
  gap: 16,

  '& button': {
    borderRadius: 120
  }
});

export const StyledSearch = styled(SSearchInput)({
  padding: `${distances.px.small} ${distances.px.base}`,
  backgroundColor: '#F8F9FA',
  borderRadius: 120,
  marginBottom: distances.px.base,
  height: 40,

  '& input': {
    '&::placeholder': {
      color: `${TextColor.SlateGrey} !important`,
      opacity: '1 !important'
    }
  },

  '& fieldset': {
    border: '1px solid #EEF0F2 !important'
  }
});
